const ar = {
  common: {
    by: "من Wadiah Mutual",
    pronounced: "تُنطق \u201cروم\u201d",
    getQuote: "احصل على عرض سعر",
    explorePlans: "استكشف خطط R0AM",
    explorePlansShort: "عرض الخطط",
    viewAllPlans: "عرض كل الخطط",
    requestQuote: "اطلب عرض سعر",
    buildPlan: "أنشئ خطة R0AM الخاصة بي",
    continue: "متابعة",
    back: "رجوع",
    bestFor: "الأنسب لـ",
    recommendedPlan: "الخطة الموصى بها",
    startingPrice: "يعتمد السعر المبدئي على الخطة والعمر وبلد الإقامة والوجهة والشروط.",
    home: "الرئيسية",
    contactCta: "تواصل مع R0AM",
    sendMessage: "إرسال الرسالة",
  },
  nav: { plans: "الخطط", smartbag: "SmartBag", telemedicine: "الطب عن بُعد", connectivity: "الاتصال", riskOptions: "خيارات المخاطر", traders: "المتداولون", partners: "الشركاء", compliance: "الامتثال", faq: "الأسئلة", contact: "تواصل" },
  langName: "العربية",
  hero: {
    badge: "عضوية التنقل العالمي",
    titleA: "حياتك لا تتسع في",
    titleAccent: "وثيقة رحلة واحدة.",
    subtitle: "R0AM by Wadiah Mutual هي مساعدة للتنقل العالمي للأشخاص الذين يعملون ويسافرون ويتاجرون وينتقلون ويحضرون المؤتمرات ويعودون إلى الوطن في دورات.",
    route: "البرتغال → الإمارات → تايلاند → فيتنام → الوطن · مصممة لمن لا يقضون عامهم في بلد واحد.",
  },
  shift: {
    overline: "تحول التنقل",
    title: "لم يعد العالم يسافر في خطوط مستقيمة.",
    oldModel: "النموذج القديم",
    oldNodes: ["الوطن", "إجازة", "الوطن"],
    oldDesc: "رحلة واحدة، وثيقة واحدة، عودة واحدة. مصممة لنمط حياة تجاوزه معظم الأشخاص العالميين.",
    newModel: "نموذج R0AM",
    newNodes: ["الوطن", "بلد العمل", "مركز معيشة منخفض التكلفة", "مركز المؤتمرات", "العائلة / بلد الوطن", "الوجهة التالية"],
    newDesc: "متكرر، متعدد البلدان، دوري. بنية حماية واحدة تتحرك معك بدلاً من إعادة الضبط عند كل حدود.",
  },
  who: { overline: "لمن R0AM", title: "مصممة للطريقة التي يعيش بها الأشخاص العالميون فعلاً." },
  cycles: { overline: "اختر دورة R0AM الخاصة بك", title: "عامك له نمط بالفعل. لقد بنينا الخطط حوله.", whoServes: "لمن تخدم", mainRisks: "المخاطر الرئيسية" },
  pillars: { overline: "ركائز المنتج", title: "منصة واحدة للتنقل العالمي الحديث.", complianceNote: "ملاحظة الامتثال: تتضمن R0AM منفعة محددة للحالات المرضية السابقة حيثما توفرت، وفقاً للحدود والشروط والاستثناءات والشروط العامة للخطة المختارة. نحن لا نزعم أبداً تغطية كاملة للحالات السابقة." },
  homePlans: { overline: "خطط R0AM", title: "بنية حماية واحدة. مبنية حول دورتك." },
  finalCta: { title: "تنقّل بين البلدان دون إعادة بناء حمايتك في كل مرة.", subtitle: "R0AM by Wadiah Mutual \u2014 {{pronounced}}. مصممة لمن لا يقضون عامهم في بلد واحد." },
  plansPage: {
    overline: "خطط R0AM",
    titleA: "اختر البنية التي",
    titleAccent: "تتحرك معك.",
    subtitle: "لا أسعار ثابتة بعد \u2014 كل خطة مصممة وفق دورتك ووجهاتك وأسرتك. اطلب عرض سعر وسنبنيها معك.",
    banner: "يعتمد التوافر والمنافع والحدود والاستثناءات والأسعار على الخطة المختارة والوجهة والعمر وبلد الإقامة والصياغة الرسمية. تتضمن R0AM منفعة محددة للحالات المرضية السابقة حيثما توفرت، وفقاً للحدود والشروط والاستثناءات والشروط العامة للخطة المختارة.",
    ctaTitle: "غير متأكد أي خطة تناسب عامك؟",
    ctaSub: "أخبرنا كيف تتنقل وسنوصي ببنية R0AM المناسبة.",
  },
  quote: {
    step: "الخطوة",
    s1Title: "من أنت؟",
    s1Hint: "هذا يساعدنا على توجيه طلبك بشكل صحيح.",
    s2Title: "إلى أين تتنقل؟",
    s2Hint: "أخبرنا بمسارك خلال الـ12 شهراً القادمة.",
    currentCountry: "البلد الحالي",
    currentPh: "مثال: البرتغال",
    nextDestination: "الوجهة التالية",
    nextPh: "مثال: الإمارات",
    countries12: "البلدان المتوقعة خلال الـ12 شهراً القادمة",
    countriesPh: "أضف بلداً واضغط Enter",
    s3Title: "من يحتاج إلى مساعدة؟",
    travelerCount: "عدد المسافرين",
    travelerCountPh: "مثال: 4",
    s4Title: "ماذا تحتاج؟",
    s4Hint: "اختر كل ما ينطبق.",
    s5Title: "بيانات التواصل",
    name: "الاسم",
    email: "البريد الإلكتروني",
    whatsapp: "واتساب",
    residence: "بلد الإقامة",
    startDate: "تاريخ البدء المفضل",
    notes: "ملاحظات",
    notesPh: "هل من شيء ينبغي أن نعرفه؟",
    s6Title: "إقرار الامتثال",
    ack1: "أفهم أن التوافر والمنافع والحدود والاستثناءات والأسعار تعتمد على الخطة المختارة والوجهة والعمر وبلد الإقامة والصياغة الرسمية.",
    ack2: "أفهم أن منافع الحالات المرضية السابقة، حيثما توفرت، محدودة وتخضع لصياغة الخطة.",
    submit: "إرسال طلب عرض السعر",
    footnote: "R0AM {{pronounced}} · تُستخدم بياناتك فقط لإعداد عرض سعرك.",
    planLabel: "الخطة",
    successTitle: "تم استلام طلب عرض السعر.",
    successBody: "شكراً لك، {{name}}. سيراجع فريقنا ملف تنقّلك في R0AM وسيتواصل معك {{channel}} قريباً.",
    onWhatsapp: "عبر واتساب",
    byEmail: "عبر البريد الإلكتروني",
    traveler: "مسافر",
    assistedTitle: "تم التوجيه إلى المراجعة المساعدة",
    assistedBody: "بما أنك أبديت اهتماماً بمنفعة حالة مرضية سابقة، يُوجَّه طلبك إلى مختص بدلاً من الدفع الفوري، لنتمكن من تأكيد الحدود والشروط المتاحة.",
    demoNote: "وضع تجريبي: تم تسجيل الحمولة في وحدة التحكم، جاهزة لـ mutualautomation.",
    backHome: "العودة إلى الرئيسية",
    explore: "استكشف الخطط",
    segments: { digital_nomad: "رحّالة رقمي", seasonal_worker: "عامل موسمي", trader_conference: "متداول / مسافر مؤتمرات", relocation: "عميل انتقال", family: "عائلة", executive_hnw: "تنفيذي / مجموعة HNW", partner_agency: "شريك / وكالة" },
    travelers: { individual: "فرد", couple: "زوجان", family: "عائلة", group: "مجموعة", entourage: "حاشية / طاقم" },
    needs: { travel_assistance: "مساعدة السفر", smartbag: "SmartBag", telemedicine: "الطب عن بُعد", connectivity: "الاتصال", risk_options: "خيارات المخاطر", monthly_payment: "دفع شهري", pre_existing: "منفعة محددة للحالة المرضية السابقة" },
    errSegment: "يرجى تحديد من أنت.",
    errCurrent: "يرجى إخبارنا ببلدك الحالي.",
    errTraveler: "يرجى تحديد من يحتاج إلى مساعدة.",
    errNeeds: "اختر حاجة واحدة على الأقل.",
    errName: "الاسم مطلوب.",
    errEmail: "البريد الإلكتروني الصحيح مطلوب.",
    errResidence: "بلد الإقامة مطلوب.",
    errAck: "يرجى تأكيد كلا الإقرارين.",
  },
  smartbag: {
    overline: "SmartBag",
    titleA: "عندما لا تتبع أمتعتك",
    titleAccent: "مسارك.",
    subtitle: "SmartBag هو نقطة الدخول البسيطة إلى R0AM. يدعم المسافرين عندما تتأخر الأمتعة أو تُفقد أو يُساء توجيهها أو معالجتها أو تتحول إلى اضطراب في الرحلة.",
    featOverline: "ما يغطيه SmartBag",
    featTitle: "دعم لكل طريقة قد تتعطل بها الأمتعة.",
    features: [
      { title: "تأخر الأمتعة", desc: "دعم بينما تلحق حقيبتك بمسارك." },
      { title: "فقدان الأمتعة", desc: "تنسيق وتوثيق عند عدم وصول الحقيبة." },
      { title: "سوء توجيه الأمتعة", desc: "مساعدة عندما تسلك حقيبتك مساراً مختلفاً عنك." },
      { title: "دعم الاستبدال الطارئ", desc: "مساعدة بالأساسيات أثناء انتظارك." },
      { title: "توثيق شركة الطيران", desc: "إرشاد بشأن تقرير PIR وأوراق المطالبة." },
      { title: "تنسيق المساعدة", desc: "نقطة تواصل واحدة بين الشركات والمطارات." },
    ],
    banner: "منافع SmartBag تخضع للحدود ومتطلبات التوثيق. التغطية تخضع للشروط والأحكام الرسمية للخطة المختارة.",
    ctaTitle: "أضف SmartBag إلى خطة R0AM.",
    ctaSub: "ابدأ بـ SmartBag، ثم أضف المساعدة والطب عن بُعد والاتصال وخيارات المخاطر حسب ما يتطلبه عامك.",
    ctaLabel: "أضف SmartBag إلى خطة R0AM",
  },
  telemedicine: {
    overline: "الطب عن بُعد",
    titleA: "دعم طبي أينما يأخذك",
    titleAccent: "مسارك.",
    subtitle: "يمكن أن تتضمن R0AM الوصول إلى الطب عن بُعد وأدوات الفرز الرقمي التي تساعد الفريق الطبي على تقييم الحالة بشكل أسرع.",
    flowOverline: "كيف يعمل",
    flowTitle: "من الطلب إلى الرعاية المنسقة.",
    steps: [
      { title: "المستخدم يطلب الدعم", desc: "تواصل مع مكتب المساعدة من أي مكان." },
      { title: "الفرز الرقمي", desc: "تساعد أدوات الفرز على هيكلة الحالة بسرعة." },
      { title: "مراجعة الفريق الطبي", desc: "يقوم مختص طبي بتقييم الموقف." },
      { title: "التوصية", desc: "تنسيق مع طبيب منزلي أو عيادة أو مستشفى." },
    ],
    banner: "الطب عن بُعد والفرز الرقمي أدوات دعم ولا تحل محل خدمات الطوارئ الطبية. أدوات الفرز بالوجه أو الرقمية ليست تشخيصاً تلقائياً \u2014 بل تساعد الفريق الطبي على تقييم الحالة أسرع. التوافر يخضع للخطة المختارة وشروط المزود.",
    ctaTitle: "احمل دعمك الطبي عبر الحدود.",
    ctaSub: "أضف الطب عن بُعد إلى خطة R0AM واحتفظ بنقطة تواصل طبية واحدة طوال العام.",
  },
  connectivity: {
    overline: "الاتصال · قريباً",
    titleA: "ابقَ متصلاً أثناء",
    titleAccent: "تنقّلك.",
    subtitle: "صُممت R0AM لدعم خيارات الاتصال العالمية المستقبلية، بما في ذلك eSIM وبيانات التجوال وأدوات الاتصال الدولية واستمرارية الهاتف للمسافرين الذين يعملون عبر الحدود.",
    featOverline: "ميزات ممكنة",
    featTitle: "استمرارية الاتصال، أينما ذهب عامك.",
    features: [
      { title: "تفعيل eSIM", desc: "فعّل بيانات محلية لحظة هبوطك." },
      { title: "شحن البيانات", desc: "شحن مرن للإقامات الأطول." },
      { title: "دعم التجوال", desc: "ابقَ على اتصال بين المناطق." },
      { title: "تنبيهات السفر", desc: "إشعارات المنطقة والمسار." },
      { title: "الوصول لجهة اتصال الطوارئ", desc: "تواصل مع المساعدة بسرعة." },
      { title: "دعم واتساب", desc: "تحدث مع المكتب حيث أنت بالفعل." },
      { title: "اتصال المسافر المؤسسي", desc: "للفرق التي تتنقل معاً." },
    ],
    ctaTitle: "كن أول من يحصل على R0AM Connectivity عند إطلاقها.",
    ctaSub: "انضم إلى قائمة الانتظار وسنخبرك عند توفر خيارات eSIM والتجوال.",
    ctaLabel: "انضم إلى قائمة الانتظار",
  },
  risk: {
    overline: "خيارات المخاطر",
    titleA: "للرحلات التي تحتاج فيها المساعدة إلى",
    titleAccent: "ما هو أبعد.",
    subtitle: "بعض المسافرين يحتاجون إلى أكثر من المساعدة العادية. يمكن لـ R0AM دعم مستويات اختيارية لإدارة المخاطر عبر شركاء معتمدين، بما في ذلك خيارات دعم أعلى للتنفيذيين ومسافري HNW والمجموعات والمناطق النائية والرحلات المعقدة.",
    featOverline: "مستويات دعم أعلى",
    featTitle: "إدارة مخاطر اختيارية عبر شركاء معتمدين.",
    features: [
      { title: "تنسيق الطوارئ", desc: "استجابة منسقة عند تصاعد المواقف." },
      { title: "خيارات الإجلاء حيثما توفرت", desc: "إجلاء طبي أو أمني عبر الشركاء." },
      { title: "خيارات دعم الأزمات", desc: "دعم منظم أثناء الأحداث المضطربة." },
      { title: "مراقبة المسافر المؤسسي", desc: "رؤية للفرق المتنقلة." },
      { title: "تنبيهات المخاطر الإقليمية", desc: "كن مستعداً للظروف المتغيرة." },
      { title: "مراجعة الوجهات عالية المخاطر", desc: "تقييم قبل السفر للمسارات المعقدة." },
    ],
    banner: "يعتمد التوافر والنطاق والاستجابة على الشريك المختار والخطة والوجهة وشروط العقد. قد تُستثنى الحرب والنزاع والعقوبات والأقاليم المقيّدة والأحداث ذات الصلة.",
    ctaTitle: "أنشئ خطة تذهب أبعد.",
    ctaSub: "أخبرنا عن مساراتك وسنبني مستوى المخاطر المناسب مع شركائنا.",
  },
  traders: {
    overline: "المتداولون والمؤتمرات",
    titleA: "مبنية من أجل",
    titleAccent: "اقتصاد المؤتمرات.",
    subtitle: "غالباً ما يتنقل محترفو الكريبتو والفوركس والفنتك والمدفوعات والتداول بين دبي وسنغافورة وليماسول ولشبونة وبانكوك وميامي وبنما ولندن. سفرهم ليس ترفيهاً. إنه جزء من بنيتهم التجارية.",
    circuitOverline: "الدائرة",
    flowOverline: "سير عملك",
    flowTitle: "تعمل R0AM قبل كل حدث وأثناءه وبعده.",
    steps: [
      { title: "قبل الحدث", desc: "عرض سعر + خطة + SmartBag + اتصال." },
      { title: "أثناء الحدث", desc: "دعم واتساب + مساعدة أمتعة + طب عن بُعد + تنبيهات مخاطر." },
      { title: "بعد الحدث", desc: "الوجهة التالية + تجديد + ترقية." },
      { title: "خطط المجموعات", desc: "اجمع فريقك على بنية واحدة." },
    ],
    ctaTitle: "اجعل السفر ميزتك، لا خطرك.",
    ctaSub: "أنشئ خطة دائرة مؤتمرات تتبع تقويمك في كل مدينة.",
    ctaLabel: "أنشئ خطة سفر المؤتمرات",
  },
  seasonal: {
    overline: "العمال الموسميون",
    titleA: "مبنية حول دورة",
    titleAccent: "العمل-الراحة-الوطن الحقيقية.",
    subtitle: "كثير من العمال الموسميين يكسبون في أستراليا أو نيوزيلندا، ويستعيدون نشاطهم في تايلاند أو فيتنام، ويعودون للوطن في الأعياد، ثم يكررون الدورة. صُممت R0AM لهذا النمط.",
    cycleOverline: "دورتك",
    cycleTitle: "بنية واحدة تتبع الموسم.",
    cycle: ["أستراليا / نيوزيلندا (عمل)", "تايلاند / فيتنام (راحة)", "بلد الوطن (أعياد)", "العودة للعمل"],
    ctaTitle: "حماية تُعاد ضبطها معك، لا ضدك.",
    ctaSub: "خيارات دفع شهري وتوجيه متعدد البلدان مبني للنمط الموسمي.",
    ctaLabel: "أنشئ خطة العامل الموسمي",
  },
  partners: {
    overline: "الشركاء",
    titleA: "كن شريكاً مع",
    titleAccent: "R0AM.",
    subtitle: "قدّم مساعدة التنقل العالمي من R0AM لعملائك ومجتمعك. نعمل مع المؤسسات التي توجّه بالفعل كيفية تنقل الأشخاص العالميين.",
    whoTitle: "مع من نتشارك",
    whoDesc: "تصبح R0AM طبقة الحماية تحت خدمتك \u2014 توجيه عروض الأسعار، عملاء جاهزون لـ CRM، متابعة عبر واتساب، وخط شركاء مصمم للتوسع معك.",
    targets: ["وكالات التأشيرات", "شركات الانتقال", "مجتمعات الرحّالة الرقميين", "مساحات العمل المشترك", "مشغلو السكن المشترك", "وسطاء الفوركس", "مجتمعات الكريبتو", "منظمو المؤتمرات", "وكالات السفر", "المكاتب العائلية", "مزودو الكونسيرج", "وكالات الدراسة/العمل بالخارج", "فرق التنقل المؤسسي"],
    types: ["وكالة تأشيرات", "شركة انتقال", "مجتمع رحّالة رقميين", "مساحة عمل مشترك", "مشغل سكن مشترك", "وسيط فوركس", "مجتمع كريبتو", "منظم مؤتمرات", "وكالة سفر", "مكتب عائلي", "مزود كونسيرج", "وكالة دراسة/عمل بالخارج", "فريق تنقل مؤسسي"],
    fCompany: "اسم الشركة",
    fContact: "الشخص المسؤول",
    fEmail: "البريد الإلكتروني",
    fWhatsapp: "واتساب",
    fWebsite: "الموقع الإلكتروني",
    fCountry: "البلد",
    fType: "نوع الشريك",
    fSelect: "اختر\u2026",
    fVolume: "الحجم الشهري المقدّر",
    fVolumePh: "مثال: 50 عميلاً / شهر",
    fMarkets: "الأسواق المخدومة",
    fMarketsPh: "مثال: الإمارات، البرتغال، جنوب شرق آسيا",
    fProducts: "المنتجات محل الاهتمام",
    fNotes: "ملاحظات",
    submit: "كن شريك R0AM",
    products: ["مساعدة التنقل العالمي", "SmartBag", "الطب عن بُعد", "الاتصال", "خيارات المخاطر"],
    successTitle: "شكراً لك، {{name}}.",
    successBody: "سيتواصل فريق الشراكات لدينا مع {{company}} قريباً.",
    errRequired: "اسم الشركة والشخص المسؤول مطلوبان.",
    errEmail: "البريد الإلكتروني الصحيح مطلوب.",
    errType: "يرجى اختيار نوع الشريك.",
    successToast: "تم استلام طلب الشراكة.",
  },
  compliance: {
    overline: "الامتثال",
    title: "كيف تُموضَع R0AM.",
    subtitle: "الشفافية جزء من العضوية. إليك بالضبط ما هي R0AM by Wadiah Mutual \u2014 وما الذي يخضع له كل خدمة.",
    positioning: "R0AM by Wadiah Mutual هي علامة لمساعدة السفر وتوزيع التنقل العالمي. تخضع التغطية والخدمات للخطة المختارة والشروط والحدود والاستثناءات وتوافر المزود والصياغة الرسمية للعقد. لا تُقدَّم Wadiah Mutual كشركة تأمين ما لم يُعتمد ذلك قانونياً.",
    disclaimersTitle: "إخلاءات المسؤولية المطلوبة",
    disclaimers: [
      "التغطية تخضع للشروط والأحكام الرسمية للخطة.",
      "منافع الحالات المرضية السابقة، حيثما توفرت، محدودة.",
      "قد تُستثنى الحرب والنزاع والعقوبات والأقاليم المقيّدة والأحداث ذات الصلة.",
      "الطب عن بُعد والفرز الرقمي لا يحلان محل خدمات الطوارئ الطبية.",
      "منافع SmartBag تخضع للحدود ومتطلبات التوثيق.",
      "خيارات إدارة المخاطر تعتمد على شروط الشريك والوجهة.",
      "قد يختلف التوافر حسب بلد الإقامة والوجهة والعمر والخطة وقواعد الاكتتاب أو المزود.",
    ],
    banner: "نحن لا نزعم أبداً تغطية كاملة للحالات المرضية السابقة. تتضمن R0AM منفعة محددة للحالات السابقة حيثما توفرت، وفقاً للحدود والشروط والاستثناءات والشروط العامة للخطة المختارة. تُوجَّه العملاء الذين يفصحون عن حالات سابقة إلى المراجعة المساعدة، لا إلى الدفع الفوري.",
    ctaTitle: "أسئلة حول التغطية والشروط؟",
    ctaSub: "سيشرح لك فريقنا بالضبط ما ينطبق على خطتك ووجهاتك.",
  },
  faqPage: { overline: "الأسئلة", title: "أسئلة، أُجيب عنها.", subtitle: "R0AM {{pronounced}}. إليك كيف تعمل العضوية وما الذي يخضع له كل جزء.", ctaTitle: "ما زال لديك سؤال؟", ctaSub: "تحدث مع فريق R0AM وسنساعدك على هيكلة الخطة المناسبة." },
  contact: {
    overline: "تواصل",
    title: "تحدّث مع R0AM.",
    subtitle: "أخبرنا كيف تتنقل وسنساعدك على هيكلة خطة التنقل العالمي المناسبة.",
    reachUs: "تواصل معنا مباشرة",
    whatsappSupport: "دعم واتساب",
    note: "R0AM {{pronounced}}. مساعدة التنقل العالمي من Wadiah Mutual.",
    fName: "الاسم",
    fEmail: "البريد الإلكتروني",
    fWhatsapp: "واتساب",
    fMessage: "الرسالة",
    successTitle: "تم إرسال الرسالة.",
    successBody: "سنتواصل مع {{name}} قريباً.",
    demoNote: "وضع تجريبي: تم تسجيل الحمولة في وحدة التحكم.",
    errName: "الاسم مطلوب.",
    errEmail: "البريد الإلكتروني الصحيح مطلوب.",
    errMessage: "يرجى إضافة رسالة.",
    sentToast: "تم إرسال الرسالة.",
  },
  footer: {
    tagline: "مساعدة التنقل العالمي للأشخاص الذين لا يقضون عامهم في بلد واحد. مساعدة واتصال ودعم أمتعة وطب عن بُعد وخيارات مخاطر للتنقل العالمي الحديث.",
    pronouncedLine: "R0AM {{pronounced}}",
    colPlatform: "المنصة",
    colWho: "لمن هي",
    colTrust: "الثقة",
    reachUs: "تواصل معنا",
    whatsappSupport: "دعم واتساب",
    newsletterPh: "البريد لتحديثات التنقل",
    newsletterErr: "يرجى إدخال بريد إلكتروني صحيح.",
    newsletterOk: "أنت على القائمة. سنتواصل معك.",
    disclaimer: "R0AM by Wadiah Mutual هي علامة لمساعدة السفر وتوزيع التنقل العالمي. تخضع التغطية والخدمات للخطة المختارة والشروط والحدود والاستثناءات وتوافر المزود والصياغة الرسمية للعقد.",
    seeCompliance: "عرض ملاحظات الامتثال",
  },
  chatbot: {
    launcher: "مساعد التنقل",
    title: "مساعد التنقل R0AM",
    online: "متصل · يرد فوراً",
    intro: "مرحباً، أنا مساعد التنقل من R0AM. يمكنني مساعدتك في إيجاد خطة مساعدة التنقل العالمي المناسبة بناءً على مكان إقامتك ووجهتك وكيفية تنقلك خلال العام.",
    askLanguage: "أولاً، ما اللغة التي تفضلها؟",
    askSegment: "ما الذي يصفك بشكل أفضل؟",
    askResidence: "في أي بلد تقيم؟",
    askCurrent: "في أي بلد أنت الآن؟",
    askNext: "ما وجهتك التالية؟",
    askCountries: "ما البلدان المتوقعة خلال الـ12 شهراً القادمة؟ (مفصولة بفواصل)",
    askTravelers: "كم عدد المسافرين الذين يحتاجون إلى مساعدة؟",
    askAge: "ما الفئات العمرية المنطبقة؟ (اختر الكل)",
    askCycle: "أي دورة سفر تناسبك أكثر؟",
    askPlan: "أي خطة تهمك أكثر؟",
    askNeeds: "ماذا تحتاج؟ (اختر الكل)",
    askPreExisting: "هل تحتاج إلى الإفصاح عن حالة مرضية سابقة؟",
    askPayment: "دفع سنوي أم شهري؟",
    askName: "ما اسمك؟",
    askEmail: "بريدك الإلكتروني؟",
    askWhatsapp: "رقم واتساب الخاص بك؟",
    yes: "نعم",
    no: "لا",
    annual: "سنوي",
    monthly: "شهري",
    next: "التالي",
    typePlaceholder: "اكتب إجابتك…",
    compliance: "تقدّم R0AM مساعدة التنقل العالمي وتوزيع مساعدة السفر. يعتمد التوافر والمنافع والأسعار والحدود والاستثناءات والخدمات على الخطة المختارة وشروط المزود وبلد الإقامة والعمر والوجهة والصياغة الرسمية. منافع الحالات المرضية السابقة، حيثما توفرت، محدودة وتخضع لشروط الخطة.",
    doneTitle: "شكراً — بياناتك جاهزة.",
    doneBody: "لقد جهّزت ملف تنقّلك في R0AM. سيتواصل فريقنا معك قريباً.",
    assistedNote: "سيُوجَّه طلبك إلى المراجعة المساعدة ليتمكن مختص من تأكيد الحدود والشروط المتاحة.",
    highValueNote: "تم تصنيفك كملف ذي أولوية — توقّع استجابة سريعة ومخصصة.",
    fallback: "تفضّل التحدث مع شخص؟",
    fallbackCta: "تواصل مع فريق R0AM",
    restart: "ابدأ من جديد",
    demoNote: "وضع تجريبي: تم حفظ البيانات، جاهزة لـ mutualautomation.",
  },
  data: {
    segments: {
      nomads: { title: "الرحّالة الرقميون", desc: "البرتغال اليوم. تايلاند الشهر القادم. الوطن في الأعياد." },
      seasonal: { title: "العمال الموسميون", desc: "أستراليا للعمل. فيتنام للراحة. أمريكا الجنوبية للعائلة. ثم العودة من جديد." },
      traders: { title: "المتداولون ومسافرو المؤتمرات", desc: "دبي، سنغافورة، ليماسول، لشبونة، ميامي \u2014 تقويمك عالمي." },
      relocation: { title: "عملاء الانتقال", desc: "هبوط هادئ بينما تُنظَّم إقامتك وسكنك وحسابك المصرفي واتصالك وتغطيتك المحلية." },
      families: { title: "العائلات العالمية", desc: "عام واحد. عدة بلدان. بنية حماية واحدة." },
      hnw: { title: "HNW والحاشية", desc: "للعائلات والمساعدين والطاقم والسائقين والمربيات وفرق الأمن ومجموعات السفر المتكررة." },
    },
    pillars: {
      assistance: { title: "مساعدة التنقل العالمي", desc: "مساعدة سنوية ومتعددة البلدان للتنقل الدولي المتكرر." },
      smartbag: { title: "SmartBag", desc: "دعم عند تأخر الأمتعة أو فقدها أو سوء توجيهها أو معالجتها أو عدم اتباعها لمسارك." },
      telemedicine: { title: "الطب عن بُعد", desc: "إرشاد طبي عن بُعد ودعم فرز أينما أخذك عامك." },
      connectivity: { title: "الاتصال", desc: "خيارات اتصال مستقبلية بأسلوب MVNO لـ eSIM والبيانات والتجوال واستمرارية الاتصال." },
      risk: { title: "خيارات المخاطر", desc: "إدارة مخاطر اختيارية وإنقاذ وإجلاء ومستويات دعم أعلى عبر شركاء معتمدين حيثما توفرت." },
      preexisting: { title: "منفعة محددة للحالة المرضية السابقة", desc: "تتضمن منفعة محددة للحالات المرضية السابقة حيثما توفرت، وفقاً للحدود والشروط والاستثناءات والشروط العامة للخطة المختارة." },
    },
    plans: {
      essential: { name: "R0AM Essential", tagline: "للسفر الدولي المتكرر البسيط.", bestFor: "المسافرون العابرون للحدود من حين لآخر ممن يتنقلون في دورات.", features: ["مساعدة سنوية متعددة الرحلات", "تنسيق سفر 24/7", "دعم أمتعة SmartBag (اختياري)", "الوصول لإرشاد الطب عن بُعد"] },
      nomad: { name: "R0AM Nomad", tagline: "للعاملين عن بُعد ومسافري الإقامة الطويلة.", bestFor: "الرحّالة الرقميون الذين يعيشون أشهراً بين البلدان.", features: ["مساعدة متعددة البلدان للإقامة الطويلة", "طب عن بُعد + فرز رقمي", "خيارات اتصال / eSIM", "SmartBag مضمّن"] },
      plus: { name: "R0AM Plus", tagline: "للمسافرين المتكررين الراغبين بميزات مساعدة أعلى.", bestFor: "المسافرون عاليو التردد المحتاجون لمستويات دعم أوسع.", features: ["حدود مساعدة محسّنة", "مكتب تنسيق ذو أولوية", "إضافات خيارات المخاطر", "منفعة محددة للحالات السابقة حيثما توفرت"] },
      trader: { name: "R0AM Trader", tagline: "لمسافري الكريبتو والفوركس والفنتك والمدفوعات والوسطاء والمؤتمرات.", bestFor: "محترفو دائرة المؤتمرات العالمية.", features: ["توجيه دائرة المؤتمرات", "دعم واتساب أثناء الفعاليات", "أولوية الأمتعة + الاتصال", "تنبيهات مخاطر إقليمية"] },
      seasonal: { name: "R0AM Seasonal", tagline: "للعمال الموسميين المتنقلين بين بلدان العمل والمراكز والوطن.", bestFor: "مسافرو دورة العمل-الراحة-الوطن.", features: ["توجيه من بلد العمل إلى بلد الوطن", "تفضيل الدفع الشهري", "الوصول للطب عن بُعد", "نوافذ تغطية في مراكز منخفضة التكلفة"] },
      family: { name: "R0AM Family", tagline: "للعائلات المتنقلة بين عدة بلدان خلال العام.", bestFor: "العائلات الدولية على بنية حماية واحدة.", features: ["بنية متعددة الأعضاء ومتعددة البلدان", "دعم الأطفال والمعالين", "طب عن بُعد للأسرة", "SmartBag للمجموعة"] },
      black: { name: "R0AM Black", tagline: "لمسافري HNW والمجموعات والطاقم والحاشية.", bestFor: "التنفيذيون والعائلات والمساعدون والسائقون والمربيات وفرق الأمن.", features: ["مجموعات سفر الحاشية والطاقم", "مستويات مخاطر بدعم أعلى", "تنسيق مخصص", "خيارات إجلاء حيثما توفرت"] },
    },
    cycles: {
      A: { label: "حلقة الاستجمام الجنوبية", serves: "العمال الموسميون والرحّالة طويلو الإقامة الذين يكسبون بالخارج ويستجمّون في مراكز منخفضة التكلفة.", risks: "فجوات بين بلدان العمل، الأمتعة في المسارات متعددة المراحل، استمرارية الرعاية الصحية.", route: ["أمريكا الجنوبية", "أستراليا / نيوزيلندا", "تايلاند / فيتنام", "بلد الوطن", "أستراليا / نيوزيلندا"] },
      B: { label: "الأطلسي\u2013الخليج\u2013آسيا", serves: "العاملون عن بُعد والمتداولون الذين يقسمون العام بين أوروبا والخليج وآسيا.", risks: "انتقالات التأشيرات، الاتصال بين المناطق، الطب عن بُعد عبر المناطق الزمنية.", route: ["البرتغال", "الإمارات", "تايلاند / فيتنام", "بلد الوطن"] },
      C: { label: "العائلة عبر الأطلسي", serves: "العائلات العالمية وعملاء الانتقال الذين يعبرون الأطلسي كل عام.", risks: "تنسيق متعدد الأعضاء، صحة المعالين، السفر في موسم الدراسة.", route: ["أوروبا / كندا", "الكاريبي", "أمريكا اللاتينية", "أوروبا / كندا"] },
      D: { label: "الخليج\u2013أوروبا\u2013آسيا", serves: "التنفيذيون ومسافرو HNW بتقويم متكرر من ثلاث مناطق.", risks: "سفر عالي القيمة، لوجستيات الحاشية، توقعات مساعدة متميزة.", route: ["الإمارات", "أوروبا", "آسيا", "بلد الوطن"] },
      E: { label: "دائرة مؤتمرات الكريبتو / الفوركس", serves: "محترفو الكريبتو والفوركس والفنتك والمدفوعات على دائرة الفعاليات العالمية.", risks: "فعاليات متتالية، اضطراب الأمتعة، دعم ميداني أثناء المؤتمرات.", route: ["دبي", "سنغافورة", "ليماسول", "لشبونة", "ميامي", "بنما"] },
    },
    faqs: [
      { q: "كيف تُنطق R0AM؟", a: "تُنطق R0AM \u201cروم\u201d. يمثل الصفر المنمّق نقطة مرجعية محمية \u2014 نقطة مساعدة ثابتة مهما كان البلد الذي تتنقل عبره." },
      { q: "هل R0AM تأمين سفر؟", a: "R0AM by Wadiah Mutual هي علامة لمساعدة السفر وتوزيع التنقل العالمي. تخضع التغطية والخدمات للخطة المختارة والشروط والحدود والاستثناءات وتوافر المزود والصياغة الرسمية للعقد." },
      { q: "لمن صُممت R0AM؟", a: "للأشخاص الذين لا يقضون عامهم في بلد واحد: الرحّالة الرقميون، العمال الموسميون، المتداولون ومسافرو المؤتمرات، عملاء الانتقال، العائلات الدولية، التنفيذيون ومجموعات سفر HNW." },
      { q: "هل تغطي R0AM الحالات المرضية السابقة؟", a: "حيثما توفرت، تتضمن R0AM منفعة محددة للحالات المرضية السابقة، وفقاً للحدود والشروط والاستثناءات والشروط العامة للخطة المختارة. نحن لا نزعم أبداً تغطية كاملة للحالات السابقة." },
      { q: "ما هو SmartBag؟", a: "SmartBag هو نقطة الدخول البسيطة إلى R0AM. يدعم المسافرين عند تأخر الأمتعة أو فقدها أو سوء توجيهها أو معالجتها أو تحولها لاضطراب في الرحلة \u2014 وفقاً للحدود ومتطلبات التوثيق." },
      { q: "هل يحل الطب عن بُعد محل رعاية الطوارئ؟", a: "لا. الطب عن بُعد والفرز الرقمي أدوات دعم لمساعدة الفريق الطبي على تقييم الحالة أسرع. وهي لا تحل محل خدمات الطوارئ الطبية." },
      { q: "كيف يعمل التسعير؟", a: "السعر غير ثابت. السعر المبدئي يخضع للخطة والعمر وبلد الإقامة والوجهة والشروط. اطلب عرض سعر وسيبني فريقنا خطة R0AM الخاصة بك." },
      { q: "كيف أبدأ؟", a: "استخدم مسار احصل على عرض سعر. يستغرق بضع دقائق وهو مصمم للجوال أولاً. يُوجَّه العملاء الذين يفصحون عن حالات سابقة إلى المراجعة المساعدة بدلاً من الدفع الفوري." },
    ],
  },
};

export default ar;
